import { PageLayout } from '../components/PageLayout';

export function TermsOfUse() {
  return (
    <PageLayout
      title="Terms of Use"
      metaTitle="Terms of Use - Abrovinc"
      metaDescription="Read the terms and conditions for using Abrovinc's website and IT consultancy services. Learn about our service agreements, licenses, and legal disclaimers."
      metaKeywords="terms of use, terms and conditions, service agreement, legal terms, Abrovinc"
      metaUrl="https://abrovinc.com/terms-of-use"
    >
      <p>
        <strong>Last updated:</strong> {new Date().getFullYear()}
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing and using the Abrovinc website and services, you accept and agree to be bound
        by the terms and provision of this agreement.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        Abrovinc provides IT consultancy services specializing in scalability, cloud solutions,
        microservices, backend development, and architecture design. We help businesses build robust
        and scalable systems.
      </p>

      <h2>3. Use License</h2>
      <p>
        Permission is granted to temporarily download one copy of the materials on Abrovinc&apos;s
        website for personal, non-commercial transitory viewing only. This is the grant of a
        license, not a transfer of title, and under this license you may not:
      </p>
      <ul>
        <li>modify or copy the materials</li>
        <li>
          use the materials for any commercial purpose or for any public display (commercial or
          non-commercial)
        </li>
        <li>
          attempt to decompile or reverse engineer any software contained on Abrovinc&apos;s website
        </li>
        <li>remove any copyright or other proprietary notations from the materials</li>
      </ul>

      <h2>4. Disclaimer</h2>
      <p>
        The materials on Abrovinc&apos;s website are provided on an &apos;as is&apos; basis.
        Abrovinc makes no warranties, expressed or implied, and hereby disclaims and negates all
        other warranties including without limitation, implied warranties or conditions of
        merchantability, fitness for a particular purpose, or non-infringement of intellectual
        property or other violation of rights.
      </p>

      <h2>5. Limitations</h2>
      <p>
        In no event shall Abrovinc or its suppliers be liable for any damages (including, without
        limitation, damages for loss of data or profit, or due to business interruption) arising out
        of the use or inability to use the materials on Abrovinc&apos;s website, even if Abrovinc or
        an authorized representative has been notified orally or in writing of the possibility of
        such damage. Because some jurisdictions do not allow limitations on implied warranties, or
        limitations of liability for consequential or incidental damages, these limitations may not
        apply to you.
      </p>

      <h2>6. Contact Information</h2>
      <p>
        If you have any questions about these Terms of Use, please contact us at:
        <br />
        Email: info@abrovinc.com
        <br />
        Address: Umeå, Sweden
      </p>
    </PageLayout>
  );
}
